import axiosClient, { unwrap } from "./axiosClient";

const catalogPath = "/api/admin/liquor-catalog";
const contactsPath = (companyId) => `/api/admin/bottle-companies/${companyId}/contacts`;

export const liquorSupplierApi = {
  listContacts: (companyId) => axiosClient.get(contactsPath(companyId)).then(unwrap),
  createContact: (companyId, data) => axiosClient.post(contactsPath(companyId), data).then(unwrap),
  updateContact: (companyId, id, data) => axiosClient.put(`${contactsPath(companyId)}/${id}`, data).then(unwrap),
  setContactActive: (companyId, id, active) => axiosClient.patch(`${contactsPath(companyId)}/${id}/status`, null, { params: { active } }).then(unwrap),
  setPrimaryContact: (companyId, id) => axiosClient.put(`${contactsPath(companyId)}/${id}/primary`).then(unwrap),
  listCatalog: (params = {}) => axiosClient.get(catalogPath, { params }).then(unwrap),
  createCatalogItem: (data) => axiosClient.post(catalogPath, data).then(unwrap),
  updateCatalogItem: (id, data) => axiosClient.put(`${catalogPath}/${id}`, data).then(unwrap),
  setCatalogItemActive: (id, active) => axiosClient.patch(`${catalogPath}/${id}/status`, null, { params: { active } }).then(unwrap),
  listActiveBottleProducts: () => axiosClient.get(`${catalogPath}/bottle-products`).then(unwrap),
};